export default __webpack_public_path__ + "static/media/chat.7e8098f6.jpg";